import { IOutfit, IOutfitAction, IOutfitData } from 'models/outfit/outfit';
import { IWardrobeItemCard } from 'models/wardrobe/wardrobeitemcard';
import { IStore } from 'redux/IStore';
import { browserHistory } from 'react-router';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;

/** Action Types */
export const REQUEST: string = 'outfit/REQUEST';
export const GET_SUCCESS: string = 'outfit/GET_SUCCESS';
export const REQUEST_FAILURE: string = 'outfit/REQUEST_FAILURE';

/** Initial State */
const initialState: IOutfitData = {
	isFetching: false,
	outfit: null,
};

/** Reducer */
export function outfitReducer(state = initialState, action: IOutfitAction) {
	switch (action.type) {
		case REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				outfit: action.payload.outfit,
				outfitItems: action.payload.outfit.itemsJArray,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		default:
			return state;
	}
}

/** Async Action Creator */
export function getOutfit(code: string, userId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + code + '?userId=' + userId,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IOutfit) => {
						dispatch(getOutfitSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function addWardrobeItemToOutfit(outfitId: string, wardrobeItem: IWardrobeItemCard) {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + outfitId + '/WardrobeItem/' + wardrobeItem.id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok) {
					// TODO: dispatch(addItemToList(wardrobeItem as IProductBaseListCard));
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_Outfit_Wardrobe_Item_Added'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Async Action Creator */
export function deleteOutfit(outfitId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/Outfit/' + outfitId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Outfit_Deleted'), kind: 'success', dismissAfter: 3000 }),
					);
					const url = '/profile/' + getState().userPreferences.code;
					browserHistory.push(url);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function request(): IOutfitAction {
	return {
		type: REQUEST,
	};
}

/** Action Creator */
export function getOutfitSuccess(data: IOutfit): IOutfitAction {
	return {
		type: GET_SUCCESS,
		payload: {
			outfit: data,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IOutfitAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}
